<template>
  <div class="flex w-full h-full justify-items-center items-center">
    <vs-tooltip text="削除" position="bottom">
      <div
        class="flex justify-center items-center action-button-icon p-1"
        @click.stop="onClickDelete(null)"
      >
        <vs-icon icon="delete_outline" size="22px" />
      </div>
    </vs-tooltip>
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  methods: {
    onClickDelete() {
      this.params.delete(this.params.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button-icon {
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: rgb(199, 199, 199);
  }
}
</style>
